// Global Chart.js theme — the competitor-demo chart language.
// Chart.js v4 exposes a singleton `Chart.defaults`, so importing this module
// once (main.ts, right after main.css) restyles every chart in the app:
// Inter type, slate-500 labels, slate-200 dashed gridlines, no axis border,
// slate-900 tooltips. Pages keep their own data/series config untouched.
import Chart from 'chart.js/auto';

Chart.defaults.font.family = "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";
Chart.defaults.font.size = 11;
Chart.defaults.color = '#64748b';            /* slate-500 — matches --text-muted */
Chart.defaults.borderColor = '#e5e9f2';      /* matches --border */
/* chart.js's TS union for shared scale defaults omits `border` (radial scales
   lack it), but the v4 runtime core scale defaults do include it. */
const scaleDefaults = Chart.defaults.scale as typeof Chart.defaults.scale & {
  border: { display: boolean; dash: number[] };
};
scaleDefaults.grid.color = '#e5e9f2';
scaleDefaults.border.display = false; /* no solid axis line */
scaleDefaults.border.dash = [3, 3];   /* dashed gridlines */
Chart.defaults.plugins.legend.labels.boxWidth = 8;
Chart.defaults.plugins.tooltip.backgroundColor = '#0f172a'; /* slate-900 — matches --text */

/* Surge indigo — matches --accent in main.css. Use for primary series. */
export const ACCENT = '#2563eb';   /* R110 #1: the blue action color (matches --accent) */
